import { render, staticRenderFns } from "./GoodsAddPage.vue?vue&type=template&id=9698c9b2&scoped=true&"
import script from "./GoodsAddPage.vue?vue&type=script&lang=js&"
export * from "./GoodsAddPage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAddPage.vue?vue&type=style&index=0&id=9698c9b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9698c9b2",
  null
  
)

export default component.exports